import { Footer } from "../components/Footer"
import { PayoutR4ConectaMethods } from "../components/payout/PayoutR4ConectaMethods"


export const PayoutR4ConectaPage = () => {
    return (
        <div className="container">
            <PayoutR4ConectaMethods />
            <Footer />
        </div>
    );
}